import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const CURRENT_VERSION = 4;

const useSelectedCompanyStore = create(
    persist(
        (set) => ({
            selectedCompany: null,
            setSelectedCompany: (company) => set({ selectedCompany: { ...company, timestamp: new Date().getTime() } }),
            clearSelectedCompany: () => set({ selectedCompany: null }),
        }),
        {
            name: 'useSelectedCompanyStore',
            version: CURRENT_VERSION,
            migrate: (persistedState, version) => {
                if (version !== CURRENT_VERSION) {
                    return {
                        selectedCompany: null,
                        version: CURRENT_VERSION,
                    };
                }
                return persistedState;
            },
        }
    )
);

export default useSelectedCompanyStore;